import { createIcon } from '@/assets/icons/helper.tsx';

export const ShieldCheck = createIcon(
  <>
    <path
      d="M19.6395 0.602091C19.4417 0.327623 19.0208 0.327623 18.823 0.602091C14.277 6.91192 5.53533 6.78927 3.32834 6.64945C3.0523 6.63197 2.8125 6.84986 2.8125 7.12643V16.0878C2.8125 22.6123 5.63824 28.8598 10.8585 32.4286C13.8363 34.4643 16.9987 36.3761 19.1154 36.9685C19.1918 36.9899 19.2707 36.9899 19.3471 36.9685C21.4638 36.3761 24.6262 34.4643 27.604 32.4286C32.8243 28.8598 35.65 22.6123 35.65 16.0878V7.12643C35.65 6.84986 35.4102 6.63197 35.1342 6.64945C32.9272 6.78927 24.1855 6.91192 19.6395 0.602091Z"
      fill="url(#paint0_linear_shield_v3)"
    />
    <path
      d="M19.4124 5.21921C19.2096 4.94939 18.7903 4.94939 18.5875 5.21921C15.1822 9.75148 8.86292 9.7667 7.02578 9.66721C6.74967 9.65223 6.51245 9.87062 6.51245 10.1471V16.807C6.51245 21.7474 8.6616 26.478 12.632 29.1804C14.8838 30.7131 17.2745 32.153 18.8843 32.6103C18.9603 32.6319 19.0396 32.6319 19.1156 32.6103C20.7254 32.153 23.1161 30.7131 25.3679 29.1804C29.3383 26.478 31.4875 21.7474 31.4875 16.807V10.1471C31.4875 9.87062 31.2502 9.65223 30.9741 9.66721C29.137 9.7667 22.8178 9.75148 19.4124 5.21921Z"
      fill="#489E9A"
    />
    <path
      d="M23.7961 14.3546C24.1273 14.0234 24.6642 14.0234 24.9953 14.3546C25.3265 14.6857 25.3265 15.2226 24.9953 15.5537L18.2118 22.3368C18.0528 22.4958 17.8373 22.5852 17.6125 22.5852C17.3876 22.5852 17.1721 22.4958 17.0131 22.3368L13.9296 19.2537C13.5985 18.9226 13.5985 18.3857 13.9296 18.0546C14.2608 17.7234 14.7977 17.7234 15.1288 18.0546L17.6125 20.5382L23.7961 14.3546Z"
      fill="#FFFCF2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_shield_v3"
        x1="19.2313"
        y1="-9.34702e-05"
        x2="19.2313"
        y2="36.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79C2BF" />
        <stop offset="1" stopColor="#BCE5D5" />
      </linearGradient>
    </defs>
  </>,
  '0 0 38 37',
  'ShieldCheck'
);
